import {
    useNotify as useUINotify,
    Color,
    type Notification,
    NotificationBlock,
} from '@keyvue/one-ui';

export default function useNotify() {
    const { notify: uiNotify } = useUINotify();

    const notify = (notification: Notification): () => void => {
        let result = uiNotify(notification);
        if (result === null) {
            result = () => {};
        }

        return result;
    };

    const notifySaving = (title?: string, duration: number = 3000) => notify({
        component: NotificationBlock,
        props: {
            color: Color.orange500,
            title: title ?? 'Bezig met opslaan...',
            text: 'Een moment geduld alstublieft',
        },
        duration,
    });

    const notifySaved = (title?: string, duration: number = 3000) => notify({
        component: NotificationBlock,
        props: {
            color: Color.green500,
            title: title ?? 'Wijzigingen opgeslagen',
        },
        duration,
    });

    const notifyDeleting = (title?: string, duration: number = 3000) => notify({
        component: NotificationBlock,
        props: {
            color: Color.orange500,
            title: title ?? 'Bezig met verwijderen...',
            text: 'Een moment geduld alstublieft',
        },
        duration,
    });

    const notifyDeleted = (title?: string, duration: number = 3000) => notify({
        component: NotificationBlock,
        props: {
            color: Color.green500,
            title: title ?? 'Het item is verwijderd',
        },
        duration,
    });

    const notifyError = (error: any, duration: number = 3000) => notify({
        component: NotificationBlock,
        props: {
            color: Color.red500,
            title: 'Er is een fout opgetreden',
            text: error?.message ?? 'Onbekende fout',
        },
        duration,
    });

    return {
        notify,
        notifySaving,
        notifySaved,
        notifyDeleting,
        notifyDeleted,
        notifyError,
    };
}
